import { jsxs as r, Fragment as t, jsx as e } from "react/jsx-runtime";
import { Link as n } from "@mui/material";
const s = {
  title: {
    en: "Updated Terms of Use and Privacy Policy",
    es: "Términos de Uso y Política de Privacidad actualizados",
    "zh-Hans": "更新的使用条款和隐私政策"
  },
  description: {
    en: /* @__PURE__ */ r(t, { children: [
      "To continue using Stenn services, you must accept our updated Terms of Use and Privacy Policy. By clicking 'Agree' you confirm that you have read and accepted the",
      " ",
      /* @__PURE__ */ e(
        n,
        {
          href: "https://stenn.com/privacy-policy",
          target: "_blank",
          underline: "hover",
          children: "Privacy and Cookie Policy"
        }
      ),
      " ",
      "and",
      " ",
      /* @__PURE__ */ e(
        n,
        {
          href: "https://stenn.com/terms-of-use",
          target: "_blank",
          underline: "hover",
          children: "Terms of Use"
        }
      ),
      "."
    ] }),
    es: /* @__PURE__ */ r(t, { children: [
      "Para continuar utilizando los servicios de Stenn, debes aceptar nuestros Términos de Uso y Política de Privacidad actualizados. Al hacer clic en 'Aceptar', confirmas que has leído y aceptado la",
      " ",
      /* @__PURE__ */ e(
        n,
        {
          href: "https://stenn.com/es/privacy-policy",
          target: "_blank",
          underline: "hover",
          children: "Política de privacidad y cookies"
        }
      ),
      " ",
      "y los",
      " ",
      /* @__PURE__ */ e(
        n,
        {
          href: "https://stenn.com/es/terms-of-use",
          target: "_blank",
          underline: "hover",
          children: "Términos de Uso"
        }
      ),
      "."
    ] }),
    "zh-Hans": /* @__PURE__ */ r(t, { children: [
      "继续使用 Stenn 服务，您必须接受我们更新的使用条款和隐私政策。点击“同意”即表示您已阅读并接受了",
      " ",
      /* @__PURE__ */ e(
        n,
        {
          href: "https://stenn.com/zh/privacy-policy",
          target: "_blank",
          underline: "hover",
          children: "隐私和 Cookie 政策"
        }
      ),
      " ",
      "以及",
      " ",
      /* @__PURE__ */ e(
        n,
        {
          href: "https://stenn.com/zh/terms-of-use",
          target: "_blank",
          underline: "hover",
          children: "使用条款"
        }
      ),
      "。"
    ] })
  },
  logOutButton: {
    en: "Log out",
    es: "Cerrar sesión",
    "zh-Hans": "退出"
  },
  agreeButton: {
    en: "Agree",
    es: "Aceptar",
    "zh-Hans": "同意"
  }
};
export {
  s as messages
};
//# sourceMappingURL=messages.mjs.map
